import { sniff, history } from '@/util'
import goPageView from './bridge/goPageView'
import { isObject } from 'lodash'
// import { Navigate } from 'react-router-dom'

// uboxApp中和微信小程序中打开新页面
const gotoPage = function (url, config, disableInH5= true ) {
  const pageConfig = {
    isPageViewCallback: false,
    opentype: '',
    ...config,
  }
  // disableInH5 = true, isPageViewCallback = false
  if ( sniff.isUboxApp || sniff.isWechatMiniProgram ) {
    goPageView(url, pageConfig?.isPageViewCallback, pageConfig?.opentype)
  } else if ( disableInH5 ) {
    isObject(url) ? history.push(url) : history.push(`${url}`)
    // Navigate(url, {replace: false}, history)
    scrollTo(0,0)
  }
}
export default gotoPage